import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axiosPrivate from 'config/axiosPrivate';
import styles from './signup.module.css';
import { useTranslation } from 'react-i18next';
const APPROVE_ADMIN_CLIENT_JOIN_REQUEST_URL = '/user/auth/approve-admin-client-join-request';

export default function ApproveAdminClientJoinRequest() {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  useEffect(() => {
    let isMounted = true;
    const params = new URLSearchParams(location.search);
    const mail = params.get('mail');
    const otpParam = params.get('otp');
    const otp = Number(otpParam);
 

    if (!mail || !otpParam || Number.isNaN(otp)) {
      history.replace('/account-activation-error');
      return undefined;
    }

    axiosPrivate
      .post(APPROVE_ADMIN_CLIENT_JOIN_REQUEST_URL, { mail, otp })
      .catch(() => {
        if (isMounted) {
          history.replace('/account-activation-error');
        }
      });

    return () => {
      isMounted = false;
    };
  }, [history, location.search]);

  return (
    <div className={styles.InscriptionInvitationcollaborateur}>
      <div className={styles.Cardintrieure}>
        <div className={styles.cardEllipse}></div>
        <div className={styles.cardText}>Benedicte</div>
        <div className={styles.Admin}>Admin</div>
        <div className={styles.iconContent}></div>
        <div className={styles.contentTeam}>Content team</div>
      </div>
      <div className={styles.CardPaul}>
        <div className={styles.cardEllipsePaul}></div>
        <div className={styles.cardTextPaul}>Paul</div>
        <div className={styles.AdminPaul}>Redacteur</div>
        <div className={styles.iconContentPaul}></div>
        <div className={styles.contentTeamPaul}>Content team</div>
      </div>
      <div className={styles.CardMarie}>
        <div className={styles.cardEllipseMarie}></div>
        <div className={styles.cardTextMarie}>Marie</div>
        <div className={styles.AdminMarie}>Chef de projet</div>
        <div className={styles.iconContentMarie}></div>
        <div className={styles.contentTeamMarie}>Content team</div>
      </div>
      <div className={styles.Ellipse30}>
        <div className={styles.smallEllipse}>
          <div className={styles.Ellipse32}>
            <div className={styles.Ellipse33}></div>
          </div>
        </div>
      </div>
      <div className={styles.smallEllipseImage}></div>
      <div className={styles.successCard}>
        <img src="/Images/new1-logo.png" alt="Logo Typix" className={styles.logo} />

        <h1 className={styles.successTitle}>{t('Accès activé !')}</h1>
        <p className={styles.successMessage}>
          <button className={styles.remindLater}>
            {t("L'accés de l'utilisateur a bien été activé. Il rejoint votre organisation en tant qu'un admin")}
          </button>
        </p>
      </div>
    </div>
  );
}
